import React , { useRef } from 'react';
import {
    Show, 
    EditButton,
    SimpleShowLayout,
    CardActions,
    ListButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment'
import Card from '@material-ui/core/Card';
import ReactToPrint from "react-to-print";
import { makeStyles } from '@material-ui/core/styles';
import jwt_decode from 'jwt-decode'
import PrintIcon from '@material-ui/icons/Print';
import Printview from './PrintProcesing'
import FileUpload from '../controls/FileUploadView'
import ErrorBoundary from '../ErrorBoundary';

const { REACT_APP_INCIDENT_LIST_URL, REACT_APP_INCIDENT_DOWNLOAD_URL } = process.env;
var process_id = '';


const ProcessingViewActions = ({ basePath, data }) => (
    <CardActions>
         <EditButton basePath={basePath} record={data} /> 
         <ListButton 
        basePath={'/processing?filter=%7B"ssn"%3A"' + `${data&&data.ssn}` +'"%7D&order=DESC&page=1&perPage=25&sort=id'} 
        label='Processing List'
        />
    </CardActions>
);

const styles = {
    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    hidden: {
        display: 'none'
    }
};

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',            
        alignItems: 'middle'
    },

    title: {
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '90%',
        maxWidth: '800',
        alignItems: 'middle',
        border: 'double',
        fontSize: '14',
        fontWeight: 'bold'
    },

    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    },

    image: {
        width: '70px',
        hight: '20px'
    }
});

const Title =({record}) =>{
    return <span>{record.last_name + ',  ' + record.first_name}</span>
}

const GetFileUpload=() => (
    <FileUpload 
        listUrl={`${REACT_APP_INCIDENT_LIST_URL}/${process_id}`}  
        id={process_id}  
        downloadUrl={`${REACT_APP_INCIDENT_DOWNLOAD_URL}/${process_id}`} 
    />
)

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    process_id = record.process_id;

    return (
      <div>
            <Printview record={record} classes={classes} ref={componentRef} />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
  };

const ProcessingView = ({ classes, ...props }) => (
    <center>
    <ErrorBoundary>
    <Show 
    {...props}  
    title={<Title/>}
    actions={<ProcessingViewActions/>} 
    >     
        <SimpleShowLayout >     
        <Print />
        <GetFileUpload  />
        </SimpleShowLayout>     
    </Show>
    </ErrorBoundary>
    </center>
);

export default withStyles(styles)(ProcessingView);
